import { useState } from 'react';
import Button from '@mui/material-next/Button';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';

export default function BotaoValores() {

    const [openDialog, setOpenDialog] = useState(false);

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (
        <>
            <Button variant="text" sx={{ fontFamily: 'sans-serif', color: 'green' }} onClick={handleOpenDialog}>
                <AttachMoneyIcon /> Valores de Inscrição
            </Button>

            <Dialog
                fullWidth={true}
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                maxWidth="lg"
                style={{ margin: 0, width: '100%', maxWidth: '100%' }}
            >
                <DialogTitle id="alert-dialog-title">
                    Valores
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        1- As inscrições serão homologadas automaticamente após o pagamento dentro dos prazos abaixo; <br />
                        2- Serão homologados automaticamente apenas inscrições pagas pelos meios disponibilizados pelo sistema de inscrição (Boleto); <br />
                        3- A Confederação Nacional de Municípios (CNM) é uma entidade privada sem fins lucrativos, portanto é ISENTA de emissão de nota fiscal.<br />
                        4- Considera-se Município contribuinte aquele que estiver com os últimos seis meses de contribuição pagos até o dia do evento.
                        <TableContainer component={Paper} style={{ marginTop: '10px' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ borderBottom: '1px solid #e0e0e0', borderRight: '1px solid #e0e0e0' }}>PARTICIPANTE</TableCell>
                                        <TableCell style={{ borderBottom: '1px solid #e0e0e0', borderRight: '1px solid #e0e0e0' }}>MUNICÍPIO CONTRIBUINTE</TableCell>
                                        <TableCell style={{ borderBottom: '1px solid #e0e0e0', borderRight: '1px solid #e0e0e0' }}>MUNICÍPIO NÃO CONTRIBUINTE</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell style={{ borderRight: '1px solid #e0e0e0' }}>Prefeita/Prefeito</TableCell>
                                        <TableCell style={{ borderRight: '1px solid #e0e0e0' }}>Isento</TableCell>
                                        <TableCell style={{ borderRight: '1px solid #e0e0e0' }}>
                                            Até 08/03 R$ 5.000,00 <br />
                                            Após 08/03 R$ 5.500,00 <br />
                                            Após 10/04 R$ 6.500,00
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ borderRight: '1px solid #e0e0e0' }}>Vereadora/Vereador</TableCell>
                                        <TableCell style={{ borderRight: '1px solid #e0e0e0' }}>Até 08/03 R$ 450,00 <br />
                                            Após 08/03 R$ 500,00 <br />
                                            Após 10/04 R$ 550,00</TableCell>
                                        <TableCell style={{ borderRight: '1px solid #e0e0e0' }}>Até 08/03 R$ 3.500,00 <br />
                                            Após 08/03 R$ 4.000,00 <br />
                                            Após 10/04 R$ 4.500,00</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ borderRight: '1px solid #e0e0e0' }}>Participante Município <br />
                                            (Vice-prefeito(a), secretário(a) e etc.)
                                        </TableCell>
                                        <TableCell style={{ borderRight: '1px solid #e0e0e0' }}>Até 08/03 R$ 450,00 <br />
                                            Após 08/03 R$ 500,00 <br />
                                            Após 10/04 R$ 550,00</TableCell>
                                        <TableCell style={{ borderRight: '1px solid #e0e0e0' }}>Até 08/03 R$ 3.500,00 <br />
                                            Após 08/03 R$ 4.000,00 <br />
                                            Após 10/04 R$ 4.500,00</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ borderRight: '1px solid #e0e0e0' }}>Demais Participantes - Brasília/DF</TableCell>
                                        <TableCell style={{ borderRight: '1px solid #e0e0e0' }}></TableCell>
                                        <TableCell>
                                            Até 08/03 R$ 5.000,00 <br />
                                            Após 08/03 R$ 5.500,00 <br />
                                            Após 10/04 R$ 6.000,00
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} autoFocus sx={{ fontFamily: 'sans-serif' }}>
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}